import TripDetailCard from './trip-detail-card';
import { getCanEditTripDetails } from './helpers';

export {
  getCanEditTripDetails,
};
export default TripDetailCard;
